import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'
import router from '@router'
import store from '@state/store'
import VueSweetalert2 from 'vue-sweetalert2'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import App from './app.vue'
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css'

// Globally register all `_base`-prefixed components
import '@components/_globals'

import vuetify from './plugins/vuetify'

Sentry.init({
  Vue,
  dsn:
    'https://991080f4cc8b42d2b4912427e4bbfcc7@o17430.ingest.sentry.io/5581592',
  autoSessionTracking: true,
  integrations: [new Integrations.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
})

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const options = {
  confirmButtonColor: '#5c6bc0',
  cancelButtonColor: '#ff7674',
}

library.add(faExclamationCircle)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueSweetalert2, options)

const app = new Vue({
  render: (h) => h(App),
  router,
  store,
  vuetify,
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
